import {
  NewQuizForm,
  QuestionBankDetail,
  QuestionBankForm,
  QuestionBanks,
  QuestionEditor,
  QuizList,
} from '@/components/quiz/authoring';
import { PageHeader } from '@/components/ui';

const LIBRARY = { kind: 'library' } as const;
const BASE = '/admin/library';

/** Nirvik's own quizzes and question banks: public, and reusable by every organization. */
export function AdminLibraryPage() {
  return <QuizList owner={LIBRARY} base={BASE} />;
}

export function AdminLibraryNewQuizPage() {
  return <NewQuizForm owner={LIBRARY} back={{ to: BASE, label: 'Library' }} />;
}

export function AdminLibraryBanksPage() {
  return (
    <>
      <PageHeader
        title="Nirvik question banks"
        description="Every organization's authors can reuse these."
        back={{ to: BASE, label: 'Library' }}
      />
      <QuestionBanks owner={LIBRARY} base={BASE} />
    </>
  );
}

export function AdminLibraryBankFormPage() {
  return <QuestionBankForm owner={LIBRARY} base={BASE} />;
}

export function AdminLibraryBankPage() {
  return <QuestionBankDetail owner={LIBRARY} base={BASE} />;
}

export function AdminLibraryQuestionEditorPage() {
  return <QuestionEditor base={BASE} />;
}
